import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boulder',
      d: 'M4.5,-0.5h0.5v0.5h-0.5zM4,0h1v0.5h-1zM-2,0.5h0.5v0.5h-0.5zM2.5,0.5h2v0.5h-2zM-1,1h5.5v0.5h-5.5zM-1,1.5h5v0.5h-5zM-0.5,2h4.5v1h-4.5zM-0.5,3h4v0.5h-4zM-0.5,3.5h1.5v1h-1.5zM1.5,3.5h2v0.5h-2zM2,4h1v0.5h-1zM-0.5,4.5h2v0.5h-2zM-0.5,5h1.5v0.5h-1.5zM-0.5,5.5h1v0.5h-1zM0,6h0.5v0.5h-0.5z',
    },
    {
      paint: 'rock',
      d: 'M-5,-0.5h0.5v0.5h-0.5zM-5,0h1.5v0.5h-1.5zM-4.5,0.5h1v1.5h-1zM-2.5,0.5h0.5v0.5h-0.5zM-3,1h2v1h-2zM-4,2h0.5v1h-0.5zM-3,2h2.5v3.5h-2.5zM4,2h1v1h-1zM4.5,3h0.5v0.5h-0.5zM-3,5.5h0.5v0.5h-0.5zM-1.5,5.5h1v0.5h-1zM-1,6h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M-1.5,-4.5h2.5v0.5h-2.5zM-1,-4h2v0.5h-2zM-0.5,-3.5h1.5v1h-1.5zM-0.5,-2.5h1v2h-1zM1,3.5h0.5v0.5h-0.5zM1,4h1v0.5h-1zM1.5,4.5h0.5v1h-0.5zM1.5,5.5h1v0.5h-1zM-0.5,6h0.5v0.5h-0.5zM1,6h0.5v0.5h-0.5zM-0.5,6.5h1v0.5h-1zM-1,7h1v0.5h-1z',
    },
    {
      paint: 'epicJade',
      d: 'M-1,-7h0.5v0.5h-0.5zM-1.5,-6.5h3v0.5h-3zM-2.5,-6h4v0.5h-4zM0.5,-2.5h0.5v0.5h-0.5zM2.5,-2h1v0.5h-1zM0.5,-1.5h0.5v0.5h-0.5zM2,-1.5h2.5v0.5h-2.5zM-1,-1h0.5v0.5h-0.5zM1.5,-1h3.5v0.5h-3.5zM-2.5,-0.5h7v0.5h-7zM-2.5,0h6.5v0.5h-6.5zM-1.5,0.5h4v0.5h-4z',
    },
    {
      paint: 'leafLight',
      d: 'M-3,-2.5h2.5v0.5h-2.5zM1,-2.5h1.5v0.5h-1.5zM-4.5,-2h4v1h-4zM0.5,-2h2v0.5h-2zM1,-1.5h1v0.5h-1zM-5,-1h1v0.5h-1zM-2.5,-1h1.5v0.5h-1.5zM0.5,-1h1v0.5h-1zM-4.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'bushDark',
      d: 'M-1.5,-7.5h1v0.5h-1zM0.5,-7.5h1v0.5h-1zM-2,-7h1v0.5h-1zM-0.5,-7h2.5v0.5h-2.5zM-2.5,-6.5h1v0.5h-1zM1.5,-6.5h1v0.5h-1zM-3,-6h0.5v0.5h-0.5zM1.5,-6h1.5v0.5h-1.5zM-3,-5.5h6v0.5h-6zM-3,-5h5.5v0.5h-5.5zM-2,-4.5h0.5v0.5h-0.5zM1,-4.5h1v0.5h-1z',
    },
    {
      paint: 'epicCrystal',
      d: 'M-4,-1h1.5v1h-1.5zM-3.5,0h1v1h-1zM-3.5,1h0.5v2h-0.5zM-4,3h1v1.5h-1z',
    },
  ],
  pixels: 348,
};
export const sprites: readonly PixelSprite[] = [variant0];
